var each = require('../each');

var toArray = require('../to-array');

var uniq = require('./uniq');

var union = function union() {
  var result = [];
  var sources = toArray(arguments);
  each(sources, function (arr) {
    result = result.concat(arr);
  });
  return uniq(result);
};

module.exports = union;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/array/union.js
// module id = 254
// module chunks = 0 1 2